export default {"src":"/_next/static/media/search-icon.cdf9f128.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};